export const PRIMARY_COLOR = '#006CF8'
export const PRIMARY_HOVER_COLOR = '#0A4FBD'
